// MainPage.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import Carousel from "./component/Carousel";
import Prompts from "./component/Prompts"; // Import the Prompts component
import { roomStyles, designStyles } from "./component/stylesData"; // Import the styles data
import "./MainPage.css";
import { Link } from "react-router-dom";

function MainPage() {
  const [imageUrl, setImageUrl] = useState(null);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedImageFile, setUploadedImageFile] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false); // for loader sync
  // const [selectedRoomId, setSelectedRoomId] = useState(null); // For room styles
  // const [selectedDesignId, setSelectedDesignId] = useState(null); // For design styles


  const [showTutorial, setShowTutorial] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [highlightElement, setHighlightElement] = useState(null);

  const {
    positivePrompt,
    negativePrompt,
    setPositivePrompt,
    setNegativePrompt,
    handleRoomSelect,
    handleDesignSelect,
    validatePrompts,
    addTechnicalParameters,
  } = Prompts({
    onPositivePromptChange: (positivePrompt) => {
      // Handle positive prompt change if needed
    },
    onNegativePromptChange: (negativePrompt) => {
      // Handle negative prompt change if needed
    },
    onRoomSelect: (positivePrompt, negativePrompt) => {
      // Handle room selection if needed
    },
    onDesignSelect: (positivePrompt, negativePrompt) => {
      // Handle design selection if needed
    },
  });

  // const backendUrl = "https://revampspacesdomainsub.loca.lt";
  // const API_BASE_URL = "http://eighty-guests-lose.loca.lt";

  // useEffect(() => {
  //   return () => {
  //     if (uploadedImage) {
  //       URL.revokeObjectURL(uploadedImage);
  //     }
  //   };
  // }, [uploadedImage]);

  useEffect(() => {
    const selector = {
      1: '.file-input-container',
      2: '.room-style-carousel',
      3: 'input[name="positive_prompt"]',
      4: '.design-styles-carousel',
      5: 'form:first-of-type button[type="submit"]',
      6: 'form:last-of-type button[type="submit"]'
    }[currentStep];
  
    if (!selector) return;
  
    const element = document.querySelector(selector);
    if (!element) return;
  
    setHighlightElement(element);
    element.classList.add('tutorial-highlighted-element');
  
    if (currentStep === 6) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  
    return () => {
      element.classList.remove('tutorial-highlighted-element');
    };
  }, [currentStep]);

  // 🆕 STEP 2: Polling /generation-progress here
useEffect(() => {
  let interval = null;

  if (isGenerating) {
    interval = setInterval(async () => {
      try {
        const res = await fetch("/generation-progress?skip_current_image=true");
        const data = await res.json();

        // JUST log progress for debugging
        console.log("Progress:", data.progress);
      } catch (err) {
        console.error("Error polling generation progress:", err);
      }
    }, 1000);
  }

  return () => clearInterval(interval);
}, [isGenerating]);

  //   if (highlightElements[currentStep]) {
  //     const element = document.querySelector(highlightElements[currentStep]);
  //     setHighlightElement(element);
  
  //     // Special handling for Step 6
  //     if (currentStep === 6 && element) {
  //       // Scroll to the bottom generate button
  //       element.scrollIntoView({ 
  //         behavior: 'smooth',
  //         block: 'center'
  //       });
        
  //       // Add extra padding at bottom if needed
  //       // window.scrollBy(0, 50);
  //     }
  //   }
  // }, [currentStep]);

  const nextStep = () => {
    if (currentStep < 6) {
      setCurrentStep(currentStep + 1);
    } else {
      if (highlightElement) {
        highlightElement.classList.remove('tutorial-highlighted-element');
        setHighlightElement(null);
      }
      setShowTutorial(false);
    }
  };

  const skipTutorial = () => {
    if (highlightElement) {
      highlightElement.classList.remove('tutorial-highlighted-element');
      setHighlightElement(null);
    }
    setShowTutorial(false);
  };

  const getTutorialText = () => {
    const texts = {
      1: "Step 1: Upload your room image by clicking here.",
      2: "Step 2: Choose the type of room you want to redesign from these options.",
      3: "Step 3: Add specific details about what you want in your room in the positive prompt. In the negative prompt, add things you don't want.",
      4: "Step 4: Select a design style that matches your taste from these options.",
      5: "Step 5: Click 'Generate for uploaded img' to see your redesigned room based on your uploaded image and selections.",
      6: "Step 6: Alternatively, you can generate a theme template by selecting room and design styles and clicking 'Generate Image' without uploading an image."
    };
    return texts[currentStep] || "";
  };





  const handleGenerate = async (e) => {
    e.preventDefault();
    if (!validatePrompts()) return;

    setError(null);
    setIsLoading(true);

    // let stopLoader = false;
    
    const fullPositivePrompt = addTechnicalParameters(positivePrompt);
    
    const formData = new FormData();
    formData.append("positive_prompt", fullPositivePrompt);
    formData.append("negative_prompt", negativePrompt);
    formData.append("steps", 20);
    formData.append("cfg_scale", 7.5);
    formData.append("width", 720);
    formData.append("height", 720);
    formData.append("sampler_index", "Euler a");

    try {
      setIsGenerating(true);// right before the axios.post
      // let stopLoader = false;
 

      const response = await axios.post("/generate", formData);
      
      if (response.data.image_url) {
        // Replace insecure HTTP URL with the frontend domain
        const proxiedUrl = response.data.image_url.replace(
          "http://216.48.178.59:8000",
          "https://revampspaces.in"
        );
        setImageUrl(proxiedUrl);
        // stopLoader = true;

        // ✅ Delay hiding loader until next repaint
        setTimeout(() => {
          setIsGenerating(false);
        }, 100);

      } else if (response.data.error) {
        setError(response.data.error);
        setIsGenerating(false);
      }
      console.log("Image URL:", response.data.image_url);
    } catch (error) {
      console.error("Error:", error);
      setError("An error occurred. Please try again.");
      setIsGenerating(false);
    } finally {
      setIsLoading(false);
      // if (stopLoader) {
      //   setTimeout(() => {
      //     setIsGenerating(false);
      //   }, 500); // half a second buffer (optional)
      // }
    }
  };

  const handleControlNet = async (e) => {
    e.preventDefault();
    if (!validatePrompts()) return;

    setError(null);
    setIsLoading(true);

    // let stopLoader = false;

    const fullPositivePrompt = addTechnicalParameters(positivePrompt);
    
    const formData = new FormData(e.target);
    formData.append("image", uploadedImageFile);
    formData.set("positive_prompt", fullPositivePrompt);
    formData.set("negative_prompt", negativePrompt);
    formData.append("steps", 20);
    formData.append("cfg_scale", 7.5);
    // formData.append("width", 450);
    // formData.append("height", 450);
    formData.append("sampler_index", "Euler a");
    formData.append("weight", 1.0);
    formData.append("resize_mode", "Scale to Fit");
    formData.append("low_vram", false);

    // for (let pair of formData.entries()) {
    //   console.log(pair[0]+ ':', pair[1]);
    // }
// https://eighty-guests-lose.loca.lt

    if (uploadedImageFile) {
          formData.append("image", uploadedImageFile); // match key with backend
    } else {
        setError("Please upload an image before generating.");
        setIsLoading(false);
      return;
    }

    // http://216.48.178.59:8000
    try {
      setIsGenerating(true);// right before the axios.post
      // let stopLoader = false;
      
      const response = await axios.post("/controlnet", formData);
      if (response.data.image_url) {
        // Replace HTTP base URL with HTTPS frontend proxy to avoid mixed content
        const proxiedUrl = response.data.image_url.replace(
          "http://216.48.178.59:8000",
          "https://revampspaces.in"
        );
        setImageUrl(proxiedUrl);

        // ✅ Delay hiding loader until next repaint
        setTimeout(() => {
          setIsGenerating(false);
        }, 100); // can be 0–200ms for visual smoothness
        
      } else if (response.data.error) {
        setError(response.data.error);
        setIsGenerating(false);
      }
      console.log("Image URL:", response.data.image_url);
    } catch (error) {
      console.error("Error:", error);
      setError("An error occurred. Please try again.");
      setIsGenerating(false);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setUploadedImage(URL.createObjectURL(file));
  //   }
  // };


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImageFile(file);
      setUploadedImage(URL.createObjectURL(file));
      setImageUploaded(true);
    }
  };
  
  const removeImage = () => {
    setUploadedImage(null);
    setUploadedImageFile(null);
    setImageUploaded(false);
    setPositivePrompt(""); // Clear positive prompt
    setNegativePrompt(""); // Clear negative prompt
    
    // Reset file input
    const fileInput = document.getElementById("file-upload");
    if (fileInput) fileInput.value = "";
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setUploadedImageFile(file);
  //     setUploadedImage(URL.createObjectURL(file));
  //     setImageUploaded(true); // Update state when an image is uploaded
  //   }
  // };

  // const removeImage = () => {
  //   setUploadedImage(null);
  //   setImageUploaded(false); // Reset the state
  // };

  return (
    <div className="main-page-wrapper">
      {isGenerating && (
          <div className="loader-overlay">
            <div className="cardloading">
              <div className="loaderloading">
                <p>Creating</p>
                <div className="wordsloading">
                  <span className="word">Walls</span>
                  <span className="word">Paints</span>
                  <span className="word">Furnishings</span>
                  <span className="word">Lights</span>
                  <span className="word">Flooring</span>
                  <span className="word">Ceiling</span>
                  <span className="word">Workers</span>
                  <span className="word">GenAi-image</span>
                </div>
              </div>
            </div>
          </div>
        )}




      {/* <div className="animated-bgmainpage">
              <div className="circlemainpage circle1mainpage"></div>
              <div className="circlemainpage circle2mainpage"></div>
              <div className="circlemainpage circle3mainpage"></div>
              <div className="circlemainpage circle4mainpage"></div>
        </div> */}
      {showTutorial && (
        <>
          <div className="tutorial-overlay">
            <div className="tutorial-step">
              <div className="tutorial-text">{getTutorialText()}</div>
              <div className="tutorial-buttons">
                <button className="tutorial-button tutorial-skip" onClick={skipTutorial}>
                  Skip Tutorial
                </button>
                <button className="tutorial-button tutorial-next" onClick={nextStep}>
                  {currentStep === 6 ? 'Finish' : 'Next'}
                </button>
              </div>
            </div>
          </div>
          {highlightElement && (
            <div
              className="tutorial-highlight"
              style={{
                width: `${highlightElement.offsetWidth}px`,
                height: `${highlightElement.offsetHeight}px`,
                top: `${highlightElement.offsetTop}px`,
                left: `${highlightElement.offsetLeft}px`,
              }}
            />
          )}
        </>
      )}
      <div className="App">
        <header className="navbarmain">
          <h1>AI Interior Designer</h1>
          
          <div className="LeftHome">
            <Link to="/tools" className="navbarmainpageh">Home</Link>
            <Link to="/furnish" className="navbarmainpager">Refurbish Page</Link>
          </div>
        </header>

        <div className="container">
        
          <div className="left-column">
            <h2>Image Generation Panel</h2>
            <form onSubmit={handleControlNet} encType="multipart/form-data">
            <div className="file-input-container">
              {/* <h5>Make Sure The Uploaded Img is in a Square(1:1) format </h5> */}
                <input
                  type="file"
                  id="file-upload"
                  name="image"
                  accept="image/*"
                  onChange={handleImageChange}
                  required
                  className="file-input"
                />
                <label htmlFor="file-upload" className="file-label">
                {uploadedImage ? (
                  <div className="image-preview">
                    <img src={uploadedImage} id="imagePreview" alt="Preview" />
                  </div>
                ) : (
                 <div className="text-center">
                   <svg
                     className="upload-icon"
                     fill="none"
                     stroke="currentColor"
                     viewBox="0 0 24 24"
                   >
                     <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                   </svg>
                   <span className="text-gray-600">Upload Image</span>
                 </div>
                  )}
                </label>
              </div>

              {imageUploaded && (
                <button
                  type="button"
                  onClick={removeImage}
                  className="mt-2 px-4 py-2 text-white bg-red-500 rounded-md"
                >
                  Remove Image
                </button>
              )}

              <Carousel 
                data={roomStyles} 
                title="Room Styles" 
                onSelect={handleRoomSelect} 
                className="room-style-carousel"
              />

              <Carousel 
                data={designStyles} 
                title="Design Styles" 
                onSelect={handleDesignSelect} 
                className="design-styles-carousel"
              />

               <input
                 type="text"
                 name="positive_prompt"
                 placeholder="Add specific details after selecting the options"
                 value={positivePrompt}
                 onChange={(e) => setPositivePrompt(e.target.value)}
                //  required
              />
               <input
                type="text"
                name="negative_prompt"
                placeholder="Enter things you don't want"
                value={negativePrompt}
                onChange={(e) => setNegativePrompt(e.target.value)}
                // style={{ 
                // color: 'transparent',
                // caretColor: 'black' // This makes the cursor visible while typing
                // }}
              />
               <button type="submit" disabled={isLoading}>
                  {isLoading ? "Processing..." : "Generate for uploaded img"}
                </button>
            </form>
            {/* <form onSubmit={handleControlNet} encType="multipart/form-data">
              <input
                type="file"
                name="image"
                accept="image/*"
                onChange={handleImageChange}
                required
              />
              {uploadedImage && (
                <div className="image-preview">
                  <img src={uploadedImage} alt="Uploaded Preview" width="200" />
                </div>
              )}
              <input
                type="text"
                name="positive_prompt"
                placeholder="Enter positive prompt"
                value={positivePrompt}
                onChange={(e) => setPositivePrompt(e.target.value)}
                required
              />
              <input
                type="text"
                name="negative_prompt"
                placeholder="Enter Negative Prompt"
                value={negativePrompt}
                onChange={(e) => setNegativePrompt(e.target.value)}
                        style={{ 
                          color: 'transparent',
                          caretColor: 'black' // This makes the cursor visible while typing
                }}

                
              />
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Processing..." : "Process with ControlNet"}
              </button>
            </form> */}

            {/* <Carousel data={roomStyles} title="Room Styles" onSelect={handleRoomSelect} />
            <Carousel data={designStyles} title="Design Styles" onSelect={handleDesignSelect} /> */}

            

            <form onSubmit={handleGenerate}>
              <div className="yolo">
               <h3>Want Inspiration? View our different styles HIT generate down here</h3>
              </div>
              <input
                type="text"
                placeholder="Enter positive prompt"
                value={positivePrompt}
                onChange={(e) => setPositivePrompt(e.target.value)}
                required
              />
              <input
                type="hidden"
                value={negativePrompt}
                onChange={(e) => setNegativePrompt(e.target.value)}
              />
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Generating..." : "Generate Image"}
              </button>
            </form>
          </div>

          <div className="right-column">
            <h2>Generated Image</h2>
            {error && <p className="error">{error}</p>}
            {imageUrl && <img src={imageUrl} alt="Generated" />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainPage;






// // MainPage.js
// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import Carousel from "./component/Carousel";
// import Prompts from "./component/Prompts"; // Import the Prompts component
// import { roomStyles, designStyles } from "./component/stylesData"; // Import the styles data
// import "./MainPage.css";
// import { Link } from "react-router-dom";

// function MainPage() {
//   const [imageUrl, setImageUrl] = useState(null);
//   const [imageUploaded, setImageUploaded] = useState(false);
//   const [uploadedImage, setUploadedImage] = useState(null);
//   const [uploadedImageFile, setUploadedImageFile] = useState(null);
//   const [error, setError] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isGenerating, setIsGenerating] = useState(false); // for loader sync
//   const fileInputRef = useRef(null); // 🆕 file input ref


//   const [showTutorial, setShowTutorial] = useState(true);
//   const [currentStep, setCurrentStep] = useState(1);
//   const [highlightElement, setHighlightElement] = useState(null);

//   const {
//     positivePrompt,
//     negativePrompt,
//     setPositivePrompt,
//     setNegativePrompt,
//     handleRoomSelect,
//     handleDesignSelect,
//     validatePrompts,
//     // addTechnicalParameters,
//     getFullPositivePrompt,    // Add this
//     getFullNegativePrompt     // Add this
//   } = Prompts({
//     onPositivePromptChange: (positivePrompt) => {},
//     onNegativePromptChange: (negativePrompt) => {},
//     onRoomSelect: (positivePrompt, negativePrompt) => {},
//     onDesignSelect: (positivePrompt, negativePrompt) => {},
//   });

//   // const {
//   //   positivePrompt,
//   //   negativePrompt,
//   //   setPositivePrompt,
//   //   setNegativePrompt,
//   //   handleRoomSelect,
//   //   handleDesignSelect,
//   //   validatePrompts,
//   //   addTechnicalParameters,
//   // } = Prompts({
//   //   onPositivePromptChange: (positivePrompt) => {
//   //     // Handle positive prompt change if needed
//   //   },
//   //   onNegativePromptChange: (negativePrompt) => {
//   //     // Handle negative prompt change if needed
//   //   },
//   //   onRoomSelect: (positivePrompt, negativePrompt) => {
//   //     // Handle room selection if needed
//   //   },
//   //   onDesignSelect: (positivePrompt, negativePrompt) => {
//   //     // Handle design selection if needed
//   //   },
//   // });

//   // const backendUrl = "https://revampspacesdomainsub.loca.lt";
//   // const API_BASE_URL = "http://eighty-guests-lose.loca.lt";

//   // useEffect(() => {
//   //   return () => {
//   //     if (uploadedImage) {
//   //       URL.revokeObjectURL(uploadedImage);
//   //     }
//   //   };
//   // }, [uploadedImage]);

//   useEffect(() => {
//     const selector = {
//       1: '.file-input-container',
//       2: '.room-style-carousel',
//       3: 'input[name="positive_prompt"]',
//       4: '.design-styles-carousel',
//       5: 'form:first-of-type button[type="submit"]',
//       6: 'form:last-of-type button[type="submit"]'
//     }[currentStep];
  
//     if (!selector) return;
  
//     const element = document.querySelector(selector);
//     if (!element) return;
  
//     setHighlightElement(element);
//     element.classList.add('tutorial-highlighted-element');
  
//     if (currentStep === 6) {
//       element.scrollIntoView({ behavior: 'smooth', block: 'center' });
//     }
  
//     return () => {
//       element.classList.remove('tutorial-highlighted-element');
//     };
//   }, [currentStep]);

//   // 🆕 STEP 2: Polling /generation-progress here
// useEffect(() => {
//   let interval = null;

//   if (isGenerating) {
//     interval = setInterval(async () => {
//       try {
//         const res = await fetch("/generation-progress?skip_current_image=true");
//         const data = await res.json();

//         // JUST log progress for debugging
//         console.log("Progress:", data.progress);
//       } catch (err) {
//         console.error("Error polling generation progress:", err);
//       }
//     }, 1000);
//   }

//   return () => clearInterval(interval);

// }, [isGenerating]);

//   //   if (highlightElements[currentStep]) {
//   //     const element = document.querySelector(highlightElements[currentStep]);
//   //     setHighlightElement(element);
  
//   //     // Special handling for Step 6
//   //     if (currentStep === 6 && element) {
//   //       // Scroll to the bottom generate button
//   //       element.scrollIntoView({ 
//   //         behavior: 'smooth',
//   //         block: 'center'
//   //       });
        
//   //       // Add extra padding at bottom if needed
//   //       // window.scrollBy(0, 50);
//   //     }
//   //   }
//   // }, [currentStep]);

//   const nextStep = () => {
//     if (currentStep < 6) {
//       setCurrentStep(currentStep + 1);
//     } else {
//       if (highlightElement) {
//         highlightElement.classList.remove('tutorial-highlighted-element');
//         setHighlightElement(null);
//       }
//       setShowTutorial(false);
//     }
//   };

//   const skipTutorial = () => {
//     if (highlightElement) {
//       highlightElement.classList.remove('tutorial-highlighted-element');
//       setHighlightElement(null);
//     }
//     setShowTutorial(false);
//   };

//   const getTutorialText = () => {
//     const texts = {
//       1: "Step 1: Upload your room image by clicking here.",
//       2: "Step 2: Choose the type of room you want to redesign from these options.",
//       3: "Step 3: Add specific details about what you want in your room in the positive prompt. In the negative prompt, add things you don't want.",
//       4: "Step 4: Select a design style that matches your taste from these options.",
//       5: "Step 5: Click 'Generate for uploaded img' to see your redesigned room based on your uploaded image and selections.",
//       6: "Step 6: Alternatively, you can generate a theme template by selecting room and design styles and clicking 'Generate Image' without uploading an image."
//     };
//     return texts[currentStep] || "";
//   };





//   const handleGenerate = async (e) => {
//     e.preventDefault();
//     // if (!validatePrompts()) return;

//     setError(null);
//     setIsLoading(true);

//     // let stopLoader = false;
    
//     // const fullPositivePrompt = addTechnicalParameters(positivePrompt);
    
//     const formData = new FormData();
//     formData.append("positive_prompt", getFullPositivePrompt()); // Use the new getter
//     formData.append("negative_prompt", getFullNegativePrompt());
//     formData.append("steps", 20);
//     formData.append("cfg_scale", 7.5);
//     formData.append("width", 720);
//     formData.append("height", 720);
//     formData.append("sampler_index", "Euler a");

//     try {
//       setIsGenerating(true);// right before the axios.post
//       // let stopLoader = false;
 

//       const response = await axios.post("/generate", formData, {
//         timeout: 300000, // 5 minutes (in milliseconds)
//       });
      
//       if (response.data.image_url) {
//         // Replace insecure HTTP URL with the frontend domain
//         const proxiedUrl = response.data.image_url.replace(
//           "http://216.48.178.59:8000",
//           "https://revampspaces.in"
//         );
//         setImageUrl(proxiedUrl);
//         // stopLoader = true;

//         // ✅ Delay hiding loader until next repaint
//         setTimeout(() => {
//           setIsGenerating(false);
//         }, 100);

//       } else if (response.data.error) {
//         setError(response.data.error);
//         setIsGenerating(false);
//       }
//       console.log("Image URL:", response.data.image_url);
//     } catch (error) {
//       console.error("Error:", error);
//       setError("An error occurred. Please try again.");
//       setIsGenerating(false);
//     } finally {
//       setIsLoading(false);
//       // if (stopLoader) {
//       //   setTimeout(() => {
//       //     setIsGenerating(false);
//       //   }, 500); // half a second buffer (optional)
//       // }
//     }
//   };

//   const handleControlNet = async (e) => {
//     e.preventDefault();
//     // 1. Check for uploaded image (mandatory)
//     if (!uploadedImageFile) {
//       setError("Please upload an image before generating.");
//       setIsLoading(false);
//       return;
//     }

//   // 2. Check if room/design were selected (via internal prompts)
//     const hasBasePrompts = getFullPositivePrompt().replace(/\(.*?\),/g, '').trim().length > 0;
//     if (!hasBasePrompts) {
//       setError("Please select both a room style and design style");
//       setIsLoading(false);
//       return;
//     }

//   // Proceed with generation
//     setError(null);
//     setIsGenerating(true);

//     // let stopLoader = false;

//     // const fullPositivePrompt = addTechnicalParameters(positivePrompt);
    
//     const formData = new FormData(e.target);
//     formData.append("image", uploadedImageFile);
//     formData.append("positive_prompt", getFullPositivePrompt()); // Use the new getter
//     formData.append("negative_prompt", getFullNegativePrompt());
//     formData.append("steps", 20);
//     formData.append("cfg_scale", 7.5);
//     // formData.append("width", 450);
//     // formData.append("height", 450);
//     formData.append("sampler_index", "Euler a");
//     formData.append("weight", 1.0);
//     formData.append("resize_mode", "Scale to Fit");
//     formData.append("low_vram", false);

//     // for (let pair of formData.entries()) {
//     //   console.log(pair[0]+ ':', pair[1]);
//     // }
// // https://eighty-guests-lose.loca.lt

//     // if (uploadedImageFile) {
//     //       formData.append("image", uploadedImageFile); // match key with backend
//     // } else {
//     //     setError("Please upload an image before generating.");
//     //     setIsLoading(false);
//     //   return;
//     // }

//     // http://216.48.178.59:8000
//     try {
//       setIsGenerating(true);// right before the axios.post
//       // let stopLoader = false;
      
//       const response = await axios.post("/controlnet", formData, {
//         timeout: 300000, // 5 minutes (in milliseconds)
//       });
//       if (response.data.image_url) {
//         // Replace HTTP base URL with HTTPS frontend proxy to avoid mixed content
//         const proxiedUrl = response.data.image_url.replace(
//           "http://216.48.178.59:8000",
//           "https://revampspaces.in"
//         );
//         setImageUrl(proxiedUrl);

//         // ✅ Delay hiding loader until next repaint
//         setTimeout(() => {
//           setIsGenerating(false);
//         }, 100); // can be 0–200ms for visual smoothness
        
//       } else if (response.data.error) {
//         setError(response.data.error);
//         setIsGenerating(false);
//       }
//       console.log("Image URL:", response.data.image_url);
//     } catch (error) {
//       console.error("Error:", error);
//       setError("An error occurred. Please try again.");
//       setIsGenerating(false);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // const handleImageChange = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     setUploadedImage(URL.createObjectURL(file));
//   //   }
//   // };


//   const handleImageChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
  
//     // Fix for iOS camera images
//     let processedFile = file;
    
//     // Check if the file is from iOS camera (often has no extension or wrong type)
//     if (file.type === "" || file.type === "image/*") {
//       // Create a new File object with proper type
//       processedFile = new File([file], "upload.jpg", { 
//         type: "image/jpeg",
//         lastModified: file.lastModified
//       });
//     }
  
//     // // Handle HEIC format (iOS default)
//     // if (file.name.toLowerCase().endsWith('.heic') || file.type === 'image/heic') {
//     //   try {
//     //     // You would need heic2any library
//     //     // npm install heic2any
//     //     const convertedBlob = await heic2any({
//     //       blob: file,
//     //       toType: "image/jpeg",
//     //       quality: 0.8
//     //     });
//     //     processedFile = new File([convertedBlob], file.name.replace(/\.heic$/i, '.jpg'), {
//     //       type: "image/jpeg",
//     //       lastModified: Date.now()
//     //     });
//     //   } catch (err) {
//     //     console.error("HEIC conversion failed:", err);
//     //     setError("Failed to process image. Please try another format.");
//     //     return;
//     //   }
//     // }
  
//     setUploadedImageFile(processedFile);
//     setUploadedImage(URL.createObjectURL(processedFile));
//     setImageUploaded(true);
//   };
//   // const handleImageChange = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     setUploadedImageFile(file);
//   //     setUploadedImage(URL.createObjectURL(file));
//   //     setImageUploaded(true); // Update state when an image is uploaded
//   //   }
//   // };

//   const removeImage = () => {
//     setUploadedImage(null);
//     setUploadedImageFile(null);
//     setImageUploaded(false);
//     // Reset prompts
//     setPositivePrompt("");
//     setNegativePrompt("");

//     if (fileInputRef.current) {
//       fileInputRef.current.value = ""; // 🧹 reset file input
//     }


//   };

//   return (
//     <div className="main-page-wrapper">
//       {isGenerating && (
//           <div className="loader-overlay">
//             <div className="cardloading">
//               <div className="loaderloading">
//                 <p>Creating</p>
//                 <div className="wordsloading">
//                   <span className="word">Walls</span>
//                   <span className="word">Paints</span>
//                   <span className="word">Furnishings</span>
//                   <span className="word">Lights</span>
//                   <span className="word">Flooring</span>
//                   <span className="word">Ceiling</span>
//                   <span className="word">Workers</span>
//                   <span className="word">GenAi-image</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}




//       {/* <div className="animated-bgmainpage">
//               <div className="circlemainpage circle1mainpage"></div>
//               <div className="circlemainpage circle2mainpage"></div>
//               <div className="circlemainpage circle3mainpage"></div>
//               <div className="circlemainpage circle4mainpage"></div>
//         </div> */}
//       {showTutorial && (
//         <>
//           <div className="tutorial-overlay">
//             <div className="tutorial-step">
//               <div className="tutorial-text">{getTutorialText()}</div>
//               <div className="tutorial-buttons">
//                 <button className="tutorial-button tutorial-skip" onClick={skipTutorial}>
//                   Skip Tutorial
//                 </button>
//                 <button className="tutorial-button tutorial-next" onClick={nextStep}>
//                   {currentStep === 6 ? 'Finish' : 'Next'}
//                 </button>
//               </div>
//             </div>
//           </div>
//           {highlightElement && (
//             <div
//               className="tutorial-highlight"
//               style={{
//                 width: `${highlightElement.offsetWidth}px`,
//                 height: `${highlightElement.offsetHeight}px`,
//                 top: `${highlightElement.offsetTop}px`,
//                 left: `${highlightElement.offsetLeft}px`,
//               }}
//             />
//           )}
//         </>
//       )}
//       <div className="App">
//         <header className="navbarmain">
//           <h1>AI Interior Designer</h1>
          
//           <div className="LeftHome">
//             <Link to="/tools" className="navbarmainpageh">Home</Link>
//             <Link to="/furnish" className="navbarmainpager">Refurbish Page</Link>
//           </div>
//         </header>

//         <div className="container">
        
//           <div className="left-column">
//             <h2>Image Generation Panel</h2>
//             <form onSubmit={handleControlNet} encType="multipart/form-data">
//             <div className="file-input-container">
//               {/* <h5>Make Sure The Uploaded Img is in a Square(1:1) format </h5> */}
//                 <input
//                   type="file"
//                   id="file-upload"
//                   name="image"
//                   accept="image/*"
//                   onChange={handleImageChange}
//                   required
//                   className="file-input"
//                   ref={fileInputRef}
//                 />
//                 <label htmlFor="file-upload" className="file-label">
//                 {uploadedImage ? (
//                   <div className="image-preview">
//                     <img src={uploadedImage} id="imagePreview" alt="Preview" />
//                   </div>
//                 ) : (
//                  <div className="text-center">
//                    <svg
//                      className="upload-icon"
//                      fill="none"
//                      stroke="currentColor"
//                      viewBox="0 0 24 24"
//                    >
//                      <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
//                     />
//                    </svg>
//                    <span className="text-gray-600">Upload Image</span>
//                  </div>
//                   )}
//                 </label>
//               </div>

//               {imageUploaded && (
//                 <button
//                   type="button"
//                   onClick={removeImage}
//                   className="mt-2 px-4 py-2 text-white bg-red-500 rounded-md"
//                 >
//                   Remove Image
//                 </button>
//               )}

//               <Carousel 
//                 data={roomStyles} 
//                 title="Room Styles" 
//                 onSelect={handleRoomSelect} 
//                 className="room-style-carousel"
//               />

//               <Carousel 
//                 data={designStyles} 
//                 title="Design Styles" 
//                 onSelect={handleDesignSelect} 
//                 className="design-styles-carousel"
//               />

//                <input
//                  type="text"
//                  name="positive_prompt"
//                  placeholder="Add specific details after selecting the options"
//                  value={positivePrompt}
//                  onChange={(e) => setPositivePrompt(e.target.value)}
//                 //  required
//               />
//                <input
//                 type="text"
//                 name="negative_prompt"
//                 placeholder="Enter things you don't want"
//                 value={negativePrompt}
//                 onChange={(e) => setNegativePrompt(e.target.value)}
//                 // style={{ 
//                 // color: 'transparent',
//                 // caretColor: 'black' // This makes the cursor visible while typing
//                 // }}
//               />
//                <button type="submit" disabled={isLoading}>
//                   {isLoading ? "Processing..." : "Generate for uploaded img"}
//                 </button>
//             </form>
//             {/* <form onSubmit={handleControlNet} encType="multipart/form-data">
//               <input
//                 type="file"
//                 name="image"
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 required
//               />
//               {uploadedImage && (
//                 <div className="image-preview">
//                   <img src={uploadedImage} alt="Uploaded Preview" width="200" />
//                 </div>
//               )}
//               <input
//                 type="text"
//                 name="positive_prompt"
//                 placeholder="Enter positive prompt"
//                 value={positivePrompt}
//                 onChange={(e) => setPositivePrompt(e.target.value)}
//                 required
//               />
//               <input
//                 type="text"
//                 name="negative_prompt"
//                 placeholder="Enter Negative Prompt"
//                 value={negativePrompt}
//                 onChange={(e) => setNegativePrompt(e.target.value)}
//                         style={{ 
//                           color: 'transparent',
//                           caretColor: 'black' // This makes the cursor visible while typing
//                 }}

                
//               />
//               <button type="submit" disabled={isLoading}>
//                 {isLoading ? "Processing..." : "Process with ControlNet"}
//               </button>
//             </form> */}

//             {/* <Carousel data={roomStyles} title="Room Styles" onSelect={handleRoomSelect} />
//             <Carousel data={designStyles} title="Design Styles" onSelect={handleDesignSelect} /> */}

            

//             <form onSubmit={handleGenerate}>
//               <div className="yolo">
//                <h3>Want Inspiration? View our different styles HIT generate down here</h3>
//               </div>
//               <input
//                 type="text"
//                 placeholder="Enter positive prompt"
//                 value={positivePrompt}
//                 onChange={(e) => setPositivePrompt(e.target.value)}
//                 // required
//               />
//               <input
//                 type="hidden"
//                 value={negativePrompt}
//                 onChange={(e) => setNegativePrompt(e.target.value)}
//               />
//               <button type="submit" disabled={isLoading}>
//                 {isLoading ? "Generating..." : "Generate Image"}
//               </button>
//             </form>
//           </div>

//           <div className="right-column">
//             <h2>Generated Image</h2>
//             {error && <p className="error">{error}</p>}
//             {imageUrl && <img src={imageUrl} alt="Generated" />}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MainPage;





































// // MainPage.js
// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import Carousel from "./component/Carousel";
// import Prompts from "./component/Prompts"; // Import the Prompts component
// import { roomStyles, designStyles } from "./component/stylesData"; // Import the styles data
// import "./MainPage.css";
// import { Link } from "react-router-dom";

// function MainPage() {
//   const [imageUrl, setImageUrl] = useState(null);
//   const [imageUploaded, setImageUploaded] = useState(false);
//   const [uploadedImage, setUploadedImage] = useState(null);
//   const [uploadedImageFile, setUploadedImageFile] = useState(null);
//   const [error, setError] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isGenerating, setIsGenerating] = useState(false); // for loader sync
//   const fileInputRef = useRef(null); // 🆕 file input ref


//   const [showTutorial, setShowTutorial] = useState(true);
//   const [currentStep, setCurrentStep] = useState(1);
//   const [highlightElement, setHighlightElement] = useState(null);

//   const {
//     positivePrompt,
//     negativePrompt,
//     setPositivePrompt,
//     setNegativePrompt,
//     handleRoomSelect,
//     handleDesignSelect,
//     validatePrompts,
//     // addTechnicalParameters,
//     getFullPositivePrompt,    // Add this
//     getFullNegativePrompt     // Add this
//   } = Prompts({
//     onPositivePromptChange: (positivePrompt) => {},
//     onNegativePromptChange: (negativePrompt) => {},
//     onRoomSelect: (positivePrompt, negativePrompt) => {},
//     onDesignSelect: (positivePrompt, negativePrompt) => {},
//   });

//   // const {
//   //   positivePrompt,
//   //   negativePrompt,
//   //   setPositivePrompt,
//   //   setNegativePrompt,
//   //   handleRoomSelect,
//   //   handleDesignSelect,
//   //   validatePrompts,
//   //   addTechnicalParameters,
//   // } = Prompts({
//   //   onPositivePromptChange: (positivePrompt) => {
//   //     // Handle positive prompt change if needed
//   //   },
//   //   onNegativePromptChange: (negativePrompt) => {
//   //     // Handle negative prompt change if needed
//   //   },
//   //   onRoomSelect: (positivePrompt, negativePrompt) => {
//   //     // Handle room selection if needed
//   //   },
//   //   onDesignSelect: (positivePrompt, negativePrompt) => {
//   //     // Handle design selection if needed
//   //   },
//   // });

//   // const backendUrl = "https://revampspacesdomainsub.loca.lt";
//   // const API_BASE_URL = "http://eighty-guests-lose.loca.lt";

//   // useEffect(() => {
//   //   return () => {
//   //     if (uploadedImage) {
//   //       URL.revokeObjectURL(uploadedImage);
//   //     }
//   //   };
//   // }, [uploadedImage]);

//   useEffect(() => {
//     const selector = {
//       1: '.file-input-container',
//       2: '.room-style-carousel',
//       3: 'input[name="positive_prompt"]',
//       4: '.design-styles-carousel',
//       5: 'form:first-of-type button[type="submit"]',
//       6: 'form:last-of-type button[type="submit"]'
//     }[currentStep];
  
//     if (!selector) return;
  
//     const element = document.querySelector(selector);
//     if (!element) return;
  
//     setHighlightElement(element);
//     element.classList.add('tutorial-highlighted-element');
  
//     if (currentStep === 6) {
//       element.scrollIntoView({ behavior: 'smooth', block: 'center' });
//     }
  
//     return () => {
//       element.classList.remove('tutorial-highlighted-element');
//     };
//   }, [currentStep]);

//   // 🆕 STEP 2: Polling /generation-progress here
// useEffect(() => {
//   let interval = null;

//   if (isGenerating) {
//     interval = setInterval(async () => {
//       try {
//         const res = await fetch("/generation-progress?skip_current_image=true");
//         const data = await res.json();

//         // JUST log progress for debugging
//         console.log("Progress:", data.progress);
//       } catch (err) {
//         console.error("Error polling generation progress:", err);
//       }
//     }, 1000);
//   }

//   return () => clearInterval(interval);
// }, [isGenerating]);

//   //   if (highlightElements[currentStep]) {
//   //     const element = document.querySelector(highlightElements[currentStep]);
//   //     setHighlightElement(element);
  
//   //     // Special handling for Step 6
//   //     if (currentStep === 6 && element) {
//   //       // Scroll to the bottom generate button
//   //       element.scrollIntoView({ 
//   //         behavior: 'smooth',
//   //         block: 'center'
//   //       });
        
//   //       // Add extra padding at bottom if needed
//   //       // window.scrollBy(0, 50);
//   //     }
//   //   }
//   // }, [currentStep]);

//   const nextStep = () => {
//     if (currentStep < 6) {
//       setCurrentStep(currentStep + 1);
//     } else {
//       if (highlightElement) {
//         highlightElement.classList.remove('tutorial-highlighted-element');
//         setHighlightElement(null);
//       }
//       setShowTutorial(false);
//     }
//   };

//   const skipTutorial = () => {
//     if (highlightElement) {
//       highlightElement.classList.remove('tutorial-highlighted-element');
//       setHighlightElement(null);
//     }
//     setShowTutorial(false);
//   };

//   const getTutorialText = () => {
//     const texts = {
//       1: "Step 1: Upload your room image by clicking here.",
//       2: "Step 2: Choose the type of room you want to redesign from these options.",
//       3: "Step 3: Add specific details about what you want in your room in the positive prompt. In the negative prompt, add things you don't want.",
//       4: "Step 4: Select a design style that matches your taste from these options.",
//       5: "Step 5: Click 'Generate for uploaded img' to see your redesigned room based on your uploaded image and selections.",
//       6: "Step 6: Alternatively, you can generate a theme template by selecting room and design styles and clicking 'Generate Image' without uploading an image."
//     };
//     return texts[currentStep] || "";
//   };





//   const handleGenerate = async (e) => {
//     e.preventDefault();
//     if (!validatePrompts()) return;

//     setError(null);
//     setIsLoading(true);

//     // let stopLoader = false;
    
//     // const fullPositivePrompt = addTechnicalParameters(positivePrompt);
    
//     const formData = new FormData();
//     formData.append("positive_prompt", getFullPositivePrompt()); // Use the new getter
//     formData.append("negative_prompt", getFullNegativePrompt());
//     formData.append("steps", 20);
//     formData.append("cfg_scale", 7.5);
//     formData.append("width", 720);
//     formData.append("height", 720);
//     formData.append("sampler_index", "Euler a");

//     try {
//       setIsGenerating(true);// right before the axios.post
//       // let stopLoader = false;
 

//       const response = await axios.post("/generate", formData, {
//         timeout: 300000, // 5 minutes (in milliseconds)
//       });
      
//       if (response.data.image_url) {
//         // Replace insecure HTTP URL with the frontend domain
//         const proxiedUrl = response.data.image_url.replace(
//           "http://216.48.178.59:8000",
//           "https://revampspaces.in"
//         );
//         setImageUrl(proxiedUrl);
//         // stopLoader = true;

//         // ✅ Delay hiding loader until next repaint
//         setTimeout(() => {
//           setIsGenerating(false);
//         }, 100);

//       } else if (response.data.error) {
//         setError(response.data.error);
//         setIsGenerating(false);
//       }
//       console.log("Image URL:", response.data.image_url);
//     } catch (error) {
//       console.error("Error:", error);
//       setError("An error occurred. Please try again.");
//       setIsGenerating(false);
//     } finally {
//       setIsLoading(false);
//       // if (stopLoader) {
//       //   setTimeout(() => {
//       //     setIsGenerating(false);
//       //   }, 500); // half a second buffer (optional)
//       // }
//     }
//   };


//   // const handleControlNet = async (e) => {
//   //   e.preventDefault();
//   //   if (!validatePrompts()) return;
  
//   //   setError(null);
//   //   setIsLoading(true);
  
//   //   const formData = new FormData(e.target);
//   //   formData.append("image", uploadedImageFile);
//   //   formData.append("positive_prompt", getFullPositivePrompt());
//   //   formData.append("negative_prompt", getFullNegativePrompt());
//   //   formData.append("steps", 20);
//   //   formData.append("cfg_scale", 7.5);
//   //   formData.append("sampler_index", "Euler a");
//   //   formData.append("weight", 1.0);
//   //   formData.append("resize_mode", "Scale to Fit");
//   //   formData.append("low_vram", false);
  
//   //   if (!uploadedImageFile) {
//   //     setError("Please upload an image before generating.");
//   //     setIsLoading(false);
//   //     return;
//   //   }
  
//   //   try {
//   //     setIsGenerating(true);
//   //     const response = await axios.post("/controlnet", formData, {
//   //       timeout: 300000,
//   //     });
  
//   //     if (response.data.image_url) {
//   //       const proxiedUrl = response.data.image_url.replace(
//   //         "http://216.48.178.59:8000",
//   //         "https://revampspaces.in"
//   //       );
//   //       setImageUrl(proxiedUrl);
//   //       setTimeout(() => setIsGenerating(false), 100);
//   //     } else if (response.data.error) {
//   //       setError(response.data.error);
//   //       setIsGenerating(false);
//   //     }
  
//   //     console.log("Image URL:", response.data.image_url);
//   //   } catch (error) {
//   //     console.error("Error:", error);
  
//   //     if (error?.code === "ECONNABORTED" || error.response?.status === 504) {
//   //       setError("Image is taking longer than usual. Checking if it's generated...");
//   //       await pollForImage();
//   //     } else {
//   //       setError("An error occurred. Please try again.");
//   //     }
  
//   //     setIsGenerating(false);
//   //   } finally {
//   //     setIsLoading(false);
//   //   }
//   // };
  
//   // const pollForImage = async (retries = 6, interval = 3000) => {
//   //   for (let i = 0; i < retries; i++) {
//   //     console.log("Polling for image (attempt", i + 1, ")");
//   //     try {
//   //       const res = await axios.get("/latest-image");
//   //       console.log("Polling result:", res.data);
  
//   //       if (res.data.image_url) {
//   //         const url = res.data.image_url.replace(
//   //           "http://216.48.178.59:8000",
//   //           "https://revampspaces.in"
//   //         );
//   //         setImageUrl(url);
//   //         return;
//   //       }
//   //     } catch (err) {
//   //       console.log("Error during polling:", err.message);
//   //     }
//   //     await new Promise((resolve) => setTimeout(resolve, interval));
//   //   }
//   //   setError("Image not found. Please try again.");
//   // };
  
//   const handleControlNet = async (e) => {
//     e.preventDefault();
//     if (!validatePrompts()) return;

//     setError(null);
//     setIsLoading(true);

//     // let stopLoader = false;

//     // const fullPositivePrompt = addTechnicalParameters(positivePrompt);
    
//     const formData = new FormData(e.target);
//     formData.append("image", uploadedImageFile);
//     formData.append("positive_prompt", getFullPositivePrompt()); // Use the new getter
//     formData.append("negative_prompt", getFullNegativePrompt());
//     formData.append("steps", 20);
//     formData.append("cfg_scale", 7.5);
//     // formData.append("width", 450);
//     // formData.append("height", 450);
//     formData.append("sampler_index", "Euler a");
//     formData.append("weight", 1.0);
//     formData.append("resize_mode", "Scale to Fit");
//     formData.append("low_vram", false);

//     // for (let pair of formData.entries()) {
//     //   console.log(pair[0]+ ':', pair[1]);
//     // }
// // https://eighty-guests-lose.loca.lt

//     if (uploadedImageFile) {
//           formData.append("image", uploadedImageFile); // match key with backend
//     } else {
//         setError("Please upload an image before generating.");
//         setIsLoading(false);
//       return;
//     }

//     // http://216.48.178.59:8000
//     try {
//       setIsGenerating(true);// right before the axios.post
//       // let stopLoader = false;
      
//       const response = await axios.post("/controlnet", formData, {
//         timeout: 300000, // 5 minutes (in milliseconds)
//       });
//       if (response.data.image_url) {
//         // Replace HTTP base URL with HTTPS frontend proxy to avoid mixed content
//         const proxiedUrl = response.data.image_url.replace(
//           "http://216.48.178.59:8000",
//           "https://revampspaces.in"
//         );
//         setImageUrl(proxiedUrl);

//         // ✅ Delay hiding loader until next repaint
//         setTimeout(() => {
//           setIsGenerating(false);
//         }, 100); // can be 0–200ms for visual smoothness
        
//       } else if (response.data.error) {
//         setError(response.data.error);
//         setIsGenerating(false);
//       }
//       console.log("Image URL:", response.data.image_url);
//     } catch (error) {
//       console.error("Error:", error);
//       setError("An error occurred. Please try again.");
//       setIsGenerating(false);
//     } finally {
//       setIsLoading(false);
//     }
//   };

// //   const pollForImage = async (retries = 6, interval = 3000) => {
// //     for (let i = 0; i < retries; i++) {
// //       console.log("Polling for image (attempt", i + 1, ")");
// //       try {
// //         const res = await axios.get("/latest-image");
// //         console.log("Polling result:", res.data);
  
// //         if (res.data.image_url) {
// //           const url = res.data.image_url.replace(
// //             "http://216.48.178.59:8000",
// //             "https://revampspaces.in"
// //           );
// //           setImageUrl(url);
// //           return;
// //         }
// //       } catch (err) {
// //         console.log("Error during polling:", err.message);
// //       }
// //       await new Promise((resolve) => setTimeout(resolve, interval));
// //     }
// //     setError("Image not found. Please try again.");
// //   };
  

//   // const handleImageChange = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     setUploadedImage(URL.createObjectURL(file));
//   //   }
//   // };


//   const handleImageChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
  
//     // Fix for iOS camera images
//     let processedFile = file;
    
//     // Check if the file is from iOS camera (often has no extension or wrong type)
//     if (file.type === "" || file.type === "image/*") {
//       // Create a new File object with proper type
//       processedFile = new File([file], "upload.jpg", { 
//         type: "image/jpeg",
//         lastModified: file.lastModified
//       });
//     }
  
//     // // Handle HEIC format (iOS default)
//     // if (file.name.toLowerCase().endsWith('.heic') || file.type === 'image/heic') {
//     //   try {
//     //     // You would need heic2any library
//     //     // npm install heic2any
//     //     const convertedBlob = await heic2any({
//     //       blob: file,
//     //       toType: "image/jpeg",
//     //       quality: 0.8
//     //     });
//     //     processedFile = new File([convertedBlob], file.name.replace(/\.heic$/i, '.jpg'), {
//     //       type: "image/jpeg",
//     //       lastModified: Date.now()
//     //     });
//     //   } catch (err) {
//     //     console.error("HEIC conversion failed:", err);
//     //     setError("Failed to process image. Please try another format.");
//     //     return;
//     //   }
//     // }
  
//     setUploadedImageFile(processedFile);
//     setUploadedImage(URL.createObjectURL(processedFile));
//     setImageUploaded(true);
//   };
//   // const handleImageChange = (e) => {
//   //   const file = e.target.files[0];
//   //   if (file) {
//   //     setUploadedImageFile(file);
//   //     setUploadedImage(URL.createObjectURL(file));
//   //     setImageUploaded(true); // Update state when an image is uploaded
//   //   }
//   // };

//   const removeImage = () => {
//     setUploadedImage(null);
//     setUploadedImageFile(null);
//     setImageUploaded(false);
//     // Reset prompts
//     setPositivePrompt("");
//     setNegativePrompt("");

//     if (fileInputRef.current) {
//       fileInputRef.current.value = ""; // 🧹 reset file input
//     }

    
//   };

//   return (
//     <div className="main-page-wrapper">
//       {isGenerating && (
//           <div className="loader-overlay">
//             <div className="cardloading">
//               <div className="loaderloading">
//                 <p>Creating</p>
//                 <div className="wordsloading">
//                   <span className="word">Walls</span>
//                   <span className="word">Paints</span>
//                   <span className="word">Furnishings</span>
//                   <span className="word">Lights</span>
//                   <span className="word">Flooring</span>
//                   <span className="word">Ceiling</span>
//                   <span className="word">Workers</span>
//                   <span className="word">GenAi-image</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}




//       {/* <div className="animated-bgmainpage">
//               <div className="circlemainpage circle1mainpage"></div>
//               <div className="circlemainpage circle2mainpage"></div>
//               <div className="circlemainpage circle3mainpage"></div>
//               <div className="circlemainpage circle4mainpage"></div>
//         </div> */}
//       {showTutorial && (
//         <>
//           <div className="tutorial-overlay">
//             <div className="tutorial-step">
//               <div className="tutorial-text">{getTutorialText()}</div>
//               <div className="tutorial-buttons">
//                 <button className="tutorial-button tutorial-skip" onClick={skipTutorial}>
//                   Skip Tutorial
//                 </button>
//                 <button className="tutorial-button tutorial-next" onClick={nextStep}>
//                   {currentStep === 6 ? 'Finish' : 'Next'}
//                 </button>
//               </div>
//             </div>
//           </div>
//           {highlightElement && (
//             <div
//               className="tutorial-highlight"
//               style={{
//                 width: `${highlightElement.offsetWidth}px`,
//                 height: `${highlightElement.offsetHeight}px`,
//                 top: `${highlightElement.offsetTop}px`,
//                 left: `${highlightElement.offsetLeft}px`,
//               }}
//             />
//           )}
//         </>
//       )}
//       <div className="App">
//         <header className="navbarmain">
//           <h1>AI Interior Designer</h1>
          
//           <div className="LeftHome">
//             <Link to="/tools" className="navbarmainpageh">Home</Link>
//             <Link to="/furnish" className="navbarmainpager">Refurbish Page</Link>
//           </div>
//         </header>

//         <div className="container">
        
//           <div className="left-column">
//             <h2>Image Generation Panel</h2>
//             <form onSubmit={handleControlNet} encType="multipart/form-data">
//             <div className="file-input-container">
//               {/* <h5>Make Sure The Uploaded Img is in a Square(1:1) format </h5> */}
//                 <input
//                   type="file"
//                   id="file-upload"
//                   name="image"
//                   accept="image/*"
//                   onChange={handleImageChange}
//                   required
//                   className="file-input"
//                   ref={fileInputRef}
//                 />
//                 <label htmlFor="file-upload" className="file-label">
//                 {uploadedImage ? (
//                   <div className="image-preview">
//                     <img src={uploadedImage} id="imagePreview" alt="Preview" />
//                   </div>
//                 ) : (
//                  <div className="text-center">
//                    <svg
//                      className="upload-icon"
//                      fill="none"
//                      stroke="currentColor"
//                      viewBox="0 0 24 24"
//                    >
//                      <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth="2"
//                       d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
//                     />
//                    </svg>
//                    <span className="text-gray-600">Upload Image</span>
//                  </div>
//                   )}
//                 </label>
//               </div>

//               {imageUploaded && (
//                 <button
//                   type="button"
//                   onClick={removeImage}
//                   className="mt-2 px-4 py-2 text-white bg-red-500 rounded-md"
//                 >
//                   Remove Image
//                 </button>
//               )}

//               <Carousel 
//                 data={roomStyles} 
//                 title="Room Styles" 
//                 onSelect={handleRoomSelect} 
//                 className="room-style-carousel"
//               />

//               <Carousel 
//                 data={designStyles} 
//                 title="Design Styles" 
//                 onSelect={handleDesignSelect} 
//                 className="design-styles-carousel"
//               />

//                <input
//                  type="text"
//                  name="positive_prompt"
//                  placeholder="Add specific details after selecting the options"
//                  value={positivePrompt}
//                  onChange={(e) => setPositivePrompt(e.target.value)}
//                 //  required
//               />
//                <input
//                 type="text"
//                 name="negative_prompt"
//                 placeholder="Enter things you don't want"
//                 value={negativePrompt}
//                 onChange={(e) => setNegativePrompt(e.target.value)}
//                 // style={{ 
//                 // color: 'transparent',
//                 // caretColor: 'black' // This makes the cursor visible while typing
//                 // }}
//               />
//                <button type="submit" disabled={isLoading}>
//                   {isLoading ? "Processing..." : "Generate for uploaded img"}
//                 </button>
//             </form>
//             {/* <form onSubmit={handleControlNet} encType="multipart/form-data">
//               <input
//                 type="file"
//                 name="image"
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 required
//               />
//               {uploadedImage && (
//                 <div className="image-preview">
//                   <img src={uploadedImage} alt="Uploaded Preview" width="200" />
//                 </div>
//               )}
//               <input
//                 type="text"
//                 name="positive_prompt"
//                 placeholder="Enter positive prompt"
//                 value={positivePrompt}
//                 onChange={(e) => setPositivePrompt(e.target.value)}
//                 required
//               />
//               <input
//                 type="text"
//                 name="negative_prompt"
//                 placeholder="Enter Negative Prompt"
//                 value={negativePrompt}
//                 onChange={(e) => setNegativePrompt(e.target.value)}
//                         style={{ 
//                           color: 'transparent',
//                           caretColor: 'black' // This makes the cursor visible while typing
//                 }}

                
//               />
//               <button type="submit" disabled={isLoading}>
//                 {isLoading ? "Processing..." : "Process with ControlNet"}
//               </button>
//             </form> */}

//             {/* <Carousel data={roomStyles} title="Room Styles" onSelect={handleRoomSelect} />
//             <Carousel data={designStyles} title="Design Styles" onSelect={handleDesignSelect} /> */}

            

//             <form onSubmit={handleGenerate}>
//               <div className="yolo">
//                <h3>Want Inspiration? View our different styles HIT generate down here</h3>
//               </div>
//               <input
//                 type="text"
//                 placeholder="Enter positive prompt"
//                 value={positivePrompt}
//                 onChange={(e) => setPositivePrompt(e.target.value)}
//                 required
//               />
//               <input
//                 type="hidden"
//                 value={negativePrompt}
//                 onChange={(e) => setNegativePrompt(e.target.value)}
//               />
//               <button type="submit" disabled={isLoading}>
//                 {isLoading ? "Generating..." : "Generate Image"}
//               </button>
//             </form>
//           </div>

//           <div className="right-column">
//             <h2>Generated Image</h2>
//             {error && <p className="error">{error}</p>}
//             {imageUrl && <img src={imageUrl} alt="Generated" />}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MainPage;




// import React, { useState, useRef, useEffect } from "react";
// import axios from "axios";
// import Carousel from "./component/Carousel";
// import "./MainPage.css";
// import { Link } from "react-router-dom";

// function MainPage() {
//   const [positivePrompt, setPositivePrompt] = useState("");
//   const [negativePrompt, setNegativePrompt] = useState("");
//   const [imageUrl, setImageUrl] = useState(null);
//   const [imageUploaded, setImageUploaded] = useState(false);
//   const [uploadedImage, setUploadedImage] = useState(null);
//   const [error, setError] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   // Canvas related states
//   const [uploadedImages, setUploadedImages] = useState([]);
//   const [canvasImages, setCanvasImages] = useState([]);
//   const canvasRef = useRef(null);
//   const [hoveredImageIndex, setHoveredImageIndex] = useState(null);
//   const [action, setAction] = useState(null); // 'drag', 'resize', 'rotate'
//   const [startMousePosition, setStartMousePosition] = useState({ x: 0, y: 0 });
//   const [startImageProperties, setStartImageProperties] = useState({
//     width: 0,
//     height: 0,
//     rotation: 0,
//   });

//   // Predefined images for the left section
//   const predefinedImages = [
//     "/images/tvpanel.png",
//     "/images/sofafornt-removebg-preview.png",
//     "/images/centertable.png",
//     "https://via.placeholder.com/150?text=Image+4",
//   ];

//   // Handle image upload for the canvas
//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const img = new window.Image();
//         img.src = event.target.result;
//         img.onload = () => {
//           setUploadedImages((prev) => [...prev, img]);
//         };
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   // Add image to canvas
//   const addImageToCanvas = (img) => {
//     setCanvasImages((prev) => [
//       ...prev,
//       {
//         image: img,
//         x: 50,
//         y: 50,
//         width: img.width / 2, // Adjust initial size if needed
//         height: img.height / 2,
//         rotation: 0,
//       },
//     ]);
//   };

//   // Remove image from canvas
//   const removeImageFromCanvas = (index) => {
//     setCanvasImages((prev) => prev.filter((_, i) => i !== index));
//     setHoveredImageIndex(null); // Reset hover state
//   };

//   // Handle mouse down to start an action
//   const handleMouseDown = (e) => {
//     const canvas = canvasRef.current;
//     const rect = canvas.getBoundingClientRect();
//     const mouseX = e.clientX - rect.left;
//     const mouseY = e.clientY - rect.top;

//     if (hoveredImageIndex !== null) {
//       const img = canvasImages[hoveredImageIndex];

//       // Check if the mouse is over the resize handle
//       if (
//         mouseX >= img.x + img.width - 10 &&
//         mouseX <= img.x + img.width &&
//         mouseY >= img.y + img.height - 10 &&
//         mouseY <= img.y + img.height
//       ) {
//         setAction("resize");
//         setStartMousePosition({ x: mouseX, y: mouseY });
//         setStartImageProperties({
//           width: img.width,
//           height: img.height,
//           rotation: img.rotation,
//         });
//         return;
//       }

//       // Check if the mouse is over the rotate handle
//       if (
//         mouseX >= img.x + img.width - 10 &&
//         mouseX <= img.x + img.width &&
//         mouseY >= img.y &&
//         mouseY <= img.y + 10
//       ) {
//         setAction("rotate");
//         setStartMousePosition({ x: mouseX, y: mouseY });
//         setStartImageProperties({
//           width: img.width,
//           height: img.height,
//           rotation: img.rotation,
//         });
//         return;
//       }

//       // Check if the mouse is over the delete button
//       if (
//         mouseX >= img.x &&
//         mouseX <= img.x + 10 &&
//         mouseY >= img.y &&
//         mouseY <= img.y + 10
//       ) {
//         removeImageFromCanvas(hoveredImageIndex);
//         return;
//       }

//       // Default action is drag
//       setAction("drag");
//       setStartMousePosition({ x: mouseX, y: mouseY });
//     }
//   };

//   // Handle mouse move to drag, resize, or rotate the hovered image
//   const handleMouseMove = (e) => {
//     const canvas = canvasRef.current;
//     const rect = canvas.getBoundingClientRect();
//     const mouseX = e.clientX - rect.left;
//     const mouseY = e.clientY - rect.top;

//     if (hoveredImageIndex !== null && action) {
//       const img = canvasImages[hoveredImageIndex];

//       if (action === "drag") {
//         // Drag the image
//         const deltaX = mouseX - startMousePosition.x;
//         const deltaY = mouseY - startMousePosition.y;
//         setCanvasImages((prev) =>
//           prev.map((img, i) =>
//             i === hoveredImageIndex
//               ? { ...img, x: img.x + deltaX, y: img.y + deltaY }
//               : img
//           )
//         );
//         setStartMousePosition({ x: mouseX, y: mouseY });
//       } else if (action === "resize") {
//         // Resize the image
//         const deltaX = mouseX - startMousePosition.x;
//         const deltaY = mouseY - startMousePosition.y;
//         const newWidth = startImageProperties.width + deltaX;
//         const newHeight = startImageProperties.height + deltaY;
//         setCanvasImages((prev) =>
//           prev.map((img, i) =>
//             i === hoveredImageIndex
//               ? { ...img, width: newWidth, height: newHeight }
//               : img
//           )
//         );
//       } else if (action === "rotate") {
//         // Rotate the image
//         const centerX = img.x + img.width / 2;
//         const centerY = img.y + img.height / 2;
//         const deltaX = mouseX - centerX;
//         const deltaY = mouseY - centerY;
//         const angle = (Math.atan2(deltaY, deltaX) * 180) / Math.PI;
//         setCanvasImages((prev) =>
//           prev.map((img, i) =>
//             i === hoveredImageIndex ? { ...img, rotation: angle } : img
//           )
//         );
//       }
//     }

//     // Check if the mouse is hovering over any image
//     for (let i = canvasImages.length - 1; i >= 0; i--) {
//       const img = canvasImages[i];
//       if (
//         mouseX >= img.x &&
//         mouseX <= img.x + img.width &&
//         mouseY >= img.y &&
//         mouseY <= img.y + img.height
//       ) {
//         setHoveredImageIndex(i);
//         break;
//       } else {
//         setHoveredImageIndex(null);
//       }
//     }
//   };

//   // Handle mouse up to stop actions
//   const handleMouseUp = () => {
//     setAction(null);
//   };

//   // Draw images on the canvas
//   const drawCanvas = () => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     canvasImages.forEach((img, index) => {
//       ctx.save();
//       ctx.translate(img.x + img.width / 2, img.y + img.height / 2);
//       ctx.rotate((img.rotation * Math.PI) / 180);
//       ctx.drawImage(
//         img.image,
//         -img.width / 2,
//         -img.height / 2,
//         img.width,
//         img.height
//       );
//       ctx.restore();

//       // Draw icons if the image is hovered
//       if (index === hoveredImageIndex) {
//         // Resize icon (bottom-right corner)
//         ctx.fillStyle = "blue";
//         ctx.fillRect(img.x + img.width - 10, img.y + img.height - 10, 10, 10);

//         // Rotate icon (top-right corner)
//         ctx.fillStyle = "green";
//         ctx.beginPath();
//         ctx.arc(img.x + img.width - 10, img.y + 10, 10, 0, 2 * Math.PI);
//         ctx.fill();

//         // Delete icon (top-left corner)
//         ctx.fillStyle = "red";
//         ctx.beginPath();
//         ctx.arc(img.x + 10, img.y + 10, 10, 0, 2 * Math.PI);
//         ctx.fill();
//       }
//     });
//   };

//   // Redraw canvas whenever canvasImages change
//   useEffect(() => {
//     drawCanvas();
//   }, [canvasImages, hoveredImageIndex]);

//   // Existing code for image generation and prompts
//   useEffect(() => {
//     return () => {
//       if (uploadedImage) {
//         URL.revokeObjectURL(uploadedImage);
//       }
//     };
//   }, [uploadedImage]);

//   const extractCorePrompt = (prompt) => {
//     const cleanPrompt = prompt.replace(
//       /(best quality:1\.4|masterpiece:1\.4|photorealistic:1\.4|ultra high res, raw photo:1\.4|hdr, hyperdetailed:1\.2|8K:1\.2|real|realistic|super detailed|4k|8k|interior),*/g,
//       ''
//     ).trim();
//     return cleanPrompt.replace(/[\(\)]/g, '').trim();
//   };

//   const addTechnicalParameters = (prompt) => {
//     return `(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, ${prompt}`;
//   };

//   const handleRoomSelect = (selectedItem) => {
//     setPositivePrompt(extractCorePrompt(selectedItem.positivePrompt));
//     setNegativePrompt(extractCorePrompt(selectedItem.negativePrompt));
//   };

//   const handleDesignSelect = (selectedItem) => {
//     const designPositivePrompt = extractCorePrompt(selectedItem.positivePrompt);
//     const designNegativePrompt = extractCorePrompt(selectedItem.negativePrompt);

//     setPositivePrompt(prev => {
//       const currentPrompt = extractCorePrompt(prev);
//       return currentPrompt ? `${currentPrompt}, ${designPositivePrompt}` : designPositivePrompt;
//     });

//     setNegativePrompt(prev => {
//       const currentPrompt = extractCorePrompt(prev);
//       return currentPrompt ? `${currentPrompt}, ${designNegativePrompt}` : designNegativePrompt;
//     });
//   };

//   const validatePrompts = () => {
//     if (!positivePrompt.trim()) {
//       setError("Positive prompt cannot be empty.");
//       return false;
//     }
//     return true;
//   };

//   const handleGenerate = async (e) => {
//     e.preventDefault();
//     if (!validatePrompts()) return;

//     setError(null);
//     setIsLoading(true);
    
//     const fullPositivePrompt = addTechnicalParameters(positivePrompt);
    
//     const formData = new FormData();
//     formData.append("positive_prompt", fullPositivePrompt);
//     formData.append("negative_prompt", negativePrompt);
//     formData.append("steps", 20);
//     formData.append("cfg_scale", 7.5);
//     formData.append("width", 400);
//     formData.append("height", 400);
//     formData.append("sampler_index", "Euler a");

//     try {
//       const response = await axios.post("https://eighty-guests-lose.loca.lt/generate", formData);
      
//       if (response.data.image_url) {
//         setImageUrl(response.data.image_url);
//       } else if (response.data.error) {
//         setError(response.data.error);
//       }
//       console.log("Image URL:", response.data.image_url);
//     } catch (error) {
//       console.error("Error:", error);
//       setError("An error occurred. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleControlNet = async (e) => {
//     e.preventDefault();
//     if (!validatePrompts()) return;

//     setError(null);
//     setIsLoading(true);

//     const fullPositivePrompt = addTechnicalParameters(positivePrompt);
    
//     const formData = new FormData(e.target);
//     formData.set("positive_prompt", fullPositivePrompt);
//     formData.set("negative_prompt", negativePrompt);
//     formData.append("steps", 20);
//     formData.append("cfg_scale", 7.5);
//     formData.append("width", 400);
//     formData.append("height", 400);
//     formData.append("sampler_index", "Euler a");
//     formData.append("weight", 1.0);
//     formData.append("resize_mode", "Scale to Fit");
//     formData.append("lowvram", false);

//     try {
//       const response = await axios.post("https://eighty-guests-lose.loca.lt/controlnet", formData);
//       if (response.data.image_url) {
//         setImageUrl(response.data.image_url);
//       } else if (response.data.error) {
//         setError(response.data.error);
//       }
//       console.log("Image URL:", response.data.image_url);
//     } catch (error) {
//       console.error("Error:", error);
//       setError("An error occurred. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setUploadedImage(URL.createObjectURL(file));
//       setImageUploaded(true); // Update state when an image is uploaded
//     }
//   };

//   const removeImage = () => {
//     setUploadedImage(null);
//     setImageUploaded(false); // Reset the state
//   };

//   const roomStyles = [
//     {
//       id: 1,
//       label: "Living Room",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, Cozy living with sofa and center table",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Cluttered space, outdated decor",
//       image: "https://via.placeholder.com/400x300.png?text=Living+Room",
//     },
//     {
//       id: 2,
//       label: "Bedroom",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, Serene bedroom with minimalistic design",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Messy room, too many decorations",
//       image: "https://via.placeholder.com/400x300.png?text=Bedroom",
//     },
//     {
//       id: 3,
//       label: "Kitchen",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, Spacious kitchen with stainless steel appliances",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Small kitchen, old appliances",
//       image: "https://via.placeholder.com/400x300.png?text=Kitchen",
//     },
//     {
//       id: 4,
//       label: "Dinning Room",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, Spacious dining room with elegant decor",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Small kitchen, old appliances",
//       image: "https://via.placeholder.com/400x300.png?text=Dinning+Room",
//     }
//   ];

//   const designStyles = [
//     {
//       id: 1,
//       label: "Mid Century Modern",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A space inspired by mid-century modern design, featuring clean lines, organic shapes, and a blend of warm wood tones with retro color accents. Geometric patterns",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Ornate details, cluttered spaces",
//       image: "/images/mid-century-modern.png",
//     },
//     {
//       id: 2,
//       label: "Bohemian",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, An eclectic and free-spirited design filled with layered textiles, vibrant patterns, and natural materials. A mix of vintage and handmade furniture, macramé wall hangings, and earthy color tones bring warmth and personality. The space feels relaxed and inviting, with global influences from Moroccan rugs to woven rattan elements. Indoor plants, mismatched décor, and cozy lighting add to the organic and artistic charm.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Minimalistic furnishings, modern decor",
//       image: "/images/boho.png",
//     },
//     {
//       id: 3,
//       label: "Industrial",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A rugged and raw industrial design that embraces exposed brick walls, concrete floors, and metal fixtures. Reclaimed wood, steel beams, and Edison bulb lighting create a bold and functional aesthetic. The space has an urban, unfinished appeal with a mix of vintage and modern elements, celebrating the beauty of raw materials and open, spacious layouts",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/industrial.png",
//     },
//     {
//       id: 4,
//       label: "Contemporary",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A sleek and sophisticated contemporary design with a focus on clean lines, neutral color palettes, and minimal ornamentation. The space is defined by smooth surfaces, high-end materials like glass and polished metal, and a refined yet inviting ambiance. Subtle textures, statement lighting, and a sense of openness contribute to the effortlessly stylish atmosphere.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/contemprary.png",
//     },
//     {
//       id: 5,
//       label: "Traditional",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A timeless and elegant design inspired by classic European aesthetics. Rich wood finishes, intricate moldings, and refined fabrics create a sense of sophistication and comfort. Antique-inspired furnishings, symmetrical layouts, and soft, warm lighting enhance the grandeur of the space while maintaining a cozy and inviting ambiance.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/mid-century-modern.jpg",
//     },
//     {
//       id: 6,
//       label: "Coastal",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A breezy and relaxed design influenced by the colors and textures of the ocean. Light, airy tones of white, blue, and sandy beige, paired with natural materials like rattan and linen, evoke a sense of coastal serenity. Large windows, organic textures, and a seamless indoor-outdoor connection define this tranquil and refreshing aesthetic.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/coastal.png",
//     },
//     {
//       id: 7,
//       label: "Minimalist",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A design rooted in simplicity, clean lines, and a clutter-free environment. Neutral tones, functional furniture, and an emphasis on negative space create a serene and calming atmosphere. Every element serves a purpose, with a focus on high-quality materials and natural light to enhance the sense of openness and tranquility.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/mid-century-modern.jpg",
//     },
//     {
//       id: 8,
//       label: "Farmhouse",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A charming and rustic farmhouse design featuring weathered wood, vintage-inspired elements, and cozy, lived-in textures. Shaker-style cabinetry, open shelving, and antique accents contribute to the nostalgic yet functional aesthetic. The atmosphere is warm and inviting, blending traditional craftsmanship with modern comforts.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/farmhouse.png",
//     },
//     {
//       id: 9,
//       label: "Art Deco",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A glamorous and bold design inspired by the 1920s and 1930s, characterized by geometric patterns, luxurious materials, and striking contrasts. Rich jewel tones, metallic finishes, and lacquered surfaces create a sense of opulence. Symmetry, intricate detailing, and dramatic lighting complete the elegant and high-fashion look.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/artdeco.png",
//     },
//     {
//       id: 10,
//       label: "Rustic",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A nature-inspired rustic design that embraces raw wood, stone, and earthy textures. Handcrafted furniture, natural imperfections, and warm, muted tones contribute to the cozy and welcoming aesthetic. The design emphasizes organic materials and a connection to the outdoors, with a focus on simplicity and authenticity.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/mid-century-modern.jpg",
//     },
//     {
//       id: 11,
//       label: "Scandinavian",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A light, airy, and functional Scandinavian design featuring a neutral color palette, natural wood finishes, and a focus on simplicity. The space is uncluttered, with clean lines, cozy textiles, and an abundance of natural light. The aesthetic prioritizes both aesthetics and practicality, creating a harmonious and peaceful environment.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/mid-century-modern.jpg",
//     },
//     {
//       id: 12,
//       label: "Transitional",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A blend of traditional and contemporary design, creating a timeless and balanced aesthetic. Neutral tones, refined textures, and classic furnishings with modern touches define the look. The space feels elegant yet approachable, with a mix of curved and straight lines, soft lighting, and a cohesive, polished atmosphere.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/mid-century-modern.jpg",
//     },
//     {
//       id: 13,
//       label: "Tropical",
//       positivePrompt: "(best quality:1.4),(masterpiece:1.4),(photorealistic:1.4),(ultra high res, raw photo:1.4),(hdr, hyperdetailed:1.2),(8K:1.2),real,(realistic),super detailed,(4k),8k,interior, A vibrant and lush tropical design inspired by island living. Bold colors, botanical prints, and woven textures create a relaxed and refreshing aesthetic. Natural materials like bamboo, rattan, and teak are combined with breezy, open spaces that bring the outdoors in. The overall vibe is carefree, warm, and inviting.",
//       negativePrompt: "(worst quality:2),(low quality:2),(normal quality:2),(poor quality:2),lowres,polar lowres,((monochrome)),((grayscale)),low res,drawing,ugly,anime,illustration,paintings,sketches,Soft colors, ornate decorations",
//       image: "/images/mid-century-modern.jpg",
//     },
//   ];

//   return (
//     <div className="main-page-wrapper">
//       <div className="App">
//         <header className="navbarmain">
//           <h1>AI Interior Designer</h1>
//           <div className="LeftHome">
//             <Link to="/">Home</Link>
//           </div>
//         </header>

//         <div className="container">
//           <div className="left-column">
//             <h3>ControlNet Image Upload</h3>
//             <form onSubmit={handleControlNet} encType="multipart/form-data">
//               <div className="file-input-container">
//                 <input
//                   type="file"
//                   id="file-upload"
//                   name="image"
//                   accept="image/*"
//                   onChange={handleImageChange}
//                   required
//                   className="file-input"
//                 />
//                 <label htmlFor="file-upload" className="file-label">
//                   {uploadedImage ? (
//                     <div className="image-preview">
//                       <img src={uploadedImage} id="imagePreview" alt="Preview" />
//                     </div>
//                   ) : (
//                     <div className="text-center">
//                       <svg
//                         className="upload-icon"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="2"
//                           d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
//                         />
//                       </svg>
//                       <span className="text-gray-600">Upload Image</span>
//                     </div>
//                   )}
//                 </label>
//               </div>

//               {imageUploaded && (
//                 <button
//                   type="button"
//                   onClick={removeImage}
//                   className="mt-2 px-4 py-2 text-white bg-red-500 rounded-md"
//                 >
//                   Remove Image
//                 </button>
//               )}
//               <input
//                 type="text"
//                 name="positive_prompt"
//                 placeholder="Enter positive prompt"
//                 value={positivePrompt}
//                 onChange={(e) => setPositivePrompt(e.target.value)}
//                 required
//               />
//               <input
//                 type="text"
//                 name="negative_prompt"
//                 placeholder="Enter Negative Prompt"
//                 value={negativePrompt}
//                 onChange={(e) => setNegativePrompt(e.target.value)}
//                 style={{ 
//                   color: 'transparent',
//                   caretColor: 'black' // This makes the cursor visible while typing
//                 }}
//               />
//               <button type="submit" disabled={isLoading}>
//                 {isLoading ? "Processing..." : "Process with ControlNet"}
//               </button>
//             </form>

//             {/* Predefined Images Section */}
//             <div className="predefined-images">
//               <h3>Predefined Images</h3>
//               <div className="predefined-images-list">
//                 {predefinedImages.map((img, index) => (
//                   <img
//                     key={index}
//                     src={img}
//                     alt={`Predefined Image ${index + 1}`}
//                     onClick={() => {
//                       const image = new window.Image();
//                       image.src = img;
//                       image.onload = () => addImageToCanvas(image);
//                     }}
//                   />
//                 ))}
//               </div>
//             </div>

//             <Carousel data={roomStyles} title="Room Styles" onSelect={handleRoomSelect} />
//             <Carousel data={designStyles} title="Design Styles" onSelect={handleDesignSelect} />

//             <form onSubmit={handleGenerate}>
//               <input
//                 type="text"
//                 placeholder="Enter positive prompt"
//                 value={positivePrompt}
//                 onChange={(e) => setPositivePrompt(e.target.value)}
//                 required
//               />
//               <input
//                 type="hidden"
//                 value={negativePrompt}
//                 onChange={(e) => setNegativePrompt(e.target.value)}
//               />
//               <button type="submit" disabled={isLoading}>
//                 {isLoading ? "Generating..." : "Generate Image"}
//               </button>
//             </form>
//           </div>

//           {/* Center Canvas Section */}
//           <div className="center-canvas">
//             <h2>Canvas</h2>
//             <canvas
//               ref={canvasRef}
//               width={800}
//               height={600}
//               onMouseDown={handleMouseDown}
//               onMouseMove={handleMouseMove}
//               onMouseUp={handleMouseUp}
//             />
//             <button
//               className="download-button"
//               onClick={() => {
//                 const canvas = canvasRef.current;
//                 const link = document.createElement("a");
//                 link.download = "canvas-image.png";
//                 link.href = canvas.toDataURL();
//                 link.click();
//               }}
//             >
//               Download Canvas
//             </button>
//           </div>

//           <div className="right-column">
//             <h2>Generated Image</h2>
//             {error && <p className="error">{error}</p>}
//             {imageUrl && <img src={imageUrl} alt="Generated" />}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MainPage;